import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { useEffect } from "preact/hooks";

import {
  Carousel,
  Recommendation,
  ControllerProvider,
//  Result,
} from "@searchspring/snap-preact-components";

import { Result, PRODUCT_CARD_TYPES } from '../../Result/Result'
import { Article, ARTICLE_CARD_TYPES } from "../../Result/Article";
import { MediaQuery } from '../../Helpers/MediaQuery'

import { ArrowUp } from "../../Icons/ArrowUp";

// CSS
import './recs.css'

@observer
export class Recs extends Component {
  constructor(props) {
    super();

    const controller = props.controller;

    if (!controller.store.profile) {
      controller.init();
      controller.search();
    }
  }

  render() {
    const controller = this.props.controller;
    const store = controller?.store;
    const arr = [...Array(9).keys()];

    //Cart drawer context check
    const type = controller.context.options.type;
    const isCartDrawer = type === 'cart-drawer';
    const isCartPage = type === 'cart-page';

    //Blog feed check
    const feedType = controller.context.options.feedType;
    const isBlogFeed = feedType === 'blog';

    //Section id, used for blog recs only currently
    const sectionId = controller.context.options.sectionId;

    const breakpointsCartDrawer = {
      0: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: true,
      },
      749: {
        slidesPerView: 1.4,
        slidesPerGroup: 1,
        spaceBetween: 20,
        centeredSlides: true,
      },
    }

    const breakpointsCartPage = {
      749: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 20,
        centeredSlides: false,
      },
      950: {
        slidesPerView: 3.2,
        slidesPerGroup: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      1100: {
        slidesPerView: 4.2,
        slidesPerGroup: 4,
        spaceBetween: 20,
        centeredSlides: false,
      },
    }

    const breakpointsCartPageMobile = {
      0: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: true,
      },
      450: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 10,
        centeredSlides: true,
      },
    }

    const breakpointsBlogRecs = {
      0: {
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: false,
      },
      549: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 20,
        centeredSlides: false,
      },
      949: {
        slidesPerView: 3.2,
        slidesPerGroup: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      1129: {
        slidesPerView: 4.2,
        slidesPerGroup: 4,
        spaceBetween: 20,
        centeredSlides: false,
      },
    };

    const breakpoints = {
      0: {
        slidesPerView: 2.3,
        slidesPerGroup: 2,
        spaceBetween: 10,
        centeredSlides: false,
      },
      749: {
        slidesPerView: 4.2,
        slidesPerGroup: 4,
        spaceBetween: 20,
        centeredSlides: false,
      },
    };

    //Function to ensure all cards are the same height
    function equalizeHeight(sectionId) {

      const allCards = document.querySelectorAll(`${sectionId} .recommendations.blog--feed .ss__recommendation-result-tracker`);

      if(!allCards) return;

      //Remove any height already assigned from a previous resize
      //If you don't do this, the results can be skewed when window.resize fires off
      allCards.forEach((card) => {
        card.style.removeProperty("height");
      });

      const arrayOfCards = Array.from(allCards);

      const maxHeight = Math.max(...arrayOfCards.map(element => element.offsetHeight));

      const shortestCards = arrayOfCards.filter(card => card.offsetHeight != maxHeight);

      if(shortestCards.length == 0) return;

      arrayOfCards.forEach((card) => {
        card.style.height = `${maxHeight}px`;
      });
    }

    useEffect(() => {
      if(isBlogFeed == true && typeof sectionId !== "undefined") {

        equalizeHeight(sectionId);

        window.addEventListener("resize", function() {
          equalizeHeight(sectionId);
        });
      }
    }, []);

    return (
      <ControllerProvider controller={this.props.controller}>
      <div>

        {/* Desktop renders */}
        <MediaQuery query="(min-width: 750px)">

          {/* Cart drawer */}
          {isCartDrawer == true && 
            <Recommendation 
              controller={controller}
              pagination={true}
              breakpoints={breakpointsCartDrawer}
              loop={true}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Result cardType={PRODUCT_CARD_TYPES.CART_UPSELL_PRODUCT_CARD} result={result} />
              ))}
            </Recommendation>
          }

          {/* Cart page */}
          {isCartPage == true && 
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowUp/>}
              nextButton={<ArrowUp/>}
              breakpoints={breakpointsCartPage}
              loop={true}
              allowTouchMove={false}
            >
              {store.results.map((result) => (
                <Result cardType={PRODUCT_CARD_TYPES.ATC_WITH_VARIANT_SELECT_PRODUCT_CARD} result={result} />
              ))}
            </Recommendation>
          }

          {/* All other recs */}
          {isCartDrawer == false && isCartPage == false && isBlogFeed == false &&
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowUp/>}
              nextButton={<ArrowUp/>}
              breakpoints={breakpoints}
              loop={true}
              allowTouchMove={false}
            >
              {store.results.map((result) => (
                <Result result={result} />
              ))}
            </Recommendation>
          }

          {isBlogFeed == true &&
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowUp/>}
              nextButton={<ArrowUp/>}
              breakpoints={breakpointsBlogRecs}
              loop={true}
              allowTouchMove={false}
            >
              {store.results.map((result) => (
                <Article result={result} cardType={ARTICLE_CARD_TYPES.BLOG_CARD} blogRec={isBlogFeed} />
              ))}
            </Recommendation>
          }
        </MediaQuery>

        {/* Mobile renders */}
        <MediaQuery query="(max-width: 749px)">
          {isCartDrawer == true &&
            <Recommendation 
              controller={controller}
              pagination={true}
              breakpoints={breakpointsCartDrawer}
              loop={true}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Result cardType={PRODUCT_CARD_TYPES.CART_UPSELL_PRODUCT_CARD} result={result} />
              ))}
            </Recommendation>
          }
          
          {isCartPage == true && 
            <Recommendation 
              controller={controller}
              pagination={true}
              breakpoints={breakpointsCartPageMobile}
              loop={true}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Result cardType={PRODUCT_CARD_TYPES.CART_UPSELL_PRODUCT_CARD} result={result} />
              ))}
            </Recommendation>
          }
          
          {isCartDrawer == false && isCartPage == false && isBlogFeed == false &&
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowUp/>}
              nextButton={<ArrowUp/>}
              breakpoints={breakpoints}
              loop={false}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Result result={result} />
              ))}
            </Recommendation>
          }
          
          {isBlogFeed == true &&
            <Recommendation 
              controller={controller}
              pagination={true}
              prevButton={<ArrowUp/>}
              nextButton={<ArrowUp/>}
              breakpoints={breakpointsBlogRecs}
              loop={true}
              allowTouchMove={true}
            >
              {store.results.map((result) => (
                <Article result={result} cardType={ARTICLE_CARD_TYPES.BLOG_CARD} blogRec={isBlogFeed} />
              ))}
            </Recommendation>
          }
        </MediaQuery>
      </div>
      </ControllerProvider>
    );
  }
}
